(function() {
  const TGLProduct = window.TGLProduct = window.TGLProduct || {};

  function formatCm(value) {
    return `${(value * 2.54).toFixed(1)} cm`;
  }

  function buildCmText(text) {
    const inchRegex = /(\d+(?:\.\d+)?)\s*"/g;
    return text.replace(inchRegex, (_, value) => formatCm(parseFloat(value)));
  }

  function applyCmConversion(detailsEl) {
    if (!detailsEl) return;
    const cells = detailsEl.querySelectorAll('.size-chart td');
    cells.forEach((cell) => {
      if (cell.querySelector('.size-chart-cm')) return;
      const text = cell.textContent.trim();
      if (!/(\d+(?:\.\d+)?)\s*"/.test(text)) return;
      const cmText = buildCmText(text);

      const inchLine = document.createElement('span');
      inchLine.className = 'size-chart-inch';
      inchLine.textContent = text;

      const cmLine = document.createElement('span');
      cmLine.className = 'size-chart-cm';
      cmLine.textContent = cmText;

      cell.textContent = '';
      cell.append(inchLine, cmLine);
    });
  }

  function bindSizeGuide(ctx) {
    if (!ctx.sizeGuideDetails || !ctx.sizeGuideOpeners.length) return;

    const openAndScroll = (event) => {
      event.preventDefault();
      if (!ctx.sizeGuideDetails.open) {
        ctx.sizeGuideDetails.open = true;
      }
      ctx.sizeGuideDetails.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    applyCmConversion(ctx.sizeGuideDetails);
    ctx.sizeGuideOpeners.forEach((btn) => btn.addEventListener('click', openAndScroll));
  }

  TGLProduct.bindSizeGuide = bindSizeGuide;
})();
